import roleEpicsMap from "./roles.epics";
import * as roleReducers from "./roles.reducers";
import { objectValues } from "@ea/shared_components/utils/object";

const roleEpics = objectValues(roleEpicsMap);

export { roleReducers, roleEpics };
